import React from "react";
import { DeveloperRecord } from "../../types/postmatch.types";
import { PostmatchTableDeveloperActivity } from "./postmatch-table-developer-activity";

export function PostmatchTableRenderDeveloper(
  onClickDeveloperOpenDDP: any,
  disableDDP?: boolean,
) {
  return function (value: {
    text: string;
    link: string;
    imageUrl: string;
    developerId: number | undefined;
    developerIdHash: string | undefined;
    jobId: number | null;
  }) {
    const developerRecord: DeveloperRecord = {
      name: value.text,
      img: value.imageUrl,
      developerId: value.developerId,
      developerIdHash: value.developerIdHash,
      jobId: value.jobId,
    };
    const onClickDeveloper = () => {
      if (typeof onClickDeveloperOpenDDP === "function" && !disableDDP) {
        onClickDeveloperOpenDDP(developerRecord);
      }
    };
    return (
      <PostmatchTableDeveloperActivity
        developerRecord={developerRecord}
        onClickDeveloper={onClickDeveloper}
        disableDDP={disableDDP}
      />
    );
  };
}
